<div class="filters">
    <div class="filter-title">
        <h1 class="h4 condensed">Filters</h1>
        <div (click)="toggleFilter()" class="fab small active" id="btn-filters">
            <i class="fas fa-times"></i>
        </div>
    </div>

    @if (AuthorisationService.hasFeature('statusFiltersAvailable')) {
        <div class="filter-group">
            <h2 class="h6 condensed">Status</h2>
            @for (status of statuses(); track status.id; let i = $index) {
                <ng-container>
                    <mat-checkbox
                        (change)="filterChange()"
                        [(ngModel)]="filter['status_' + status.id]"
                        [disabled]="filter['status_' + status.id + '_disable']"
                        [value]="status.id"
                        color="primary">
                        <span [innerHTML]="status['img'] | safeHtml"></span>
                        {{status.name}}
                        @if (statusCounts().has(status.id)) {
                            ({{statusCounts().get(status.id)}})
                        }
                    </mat-checkbox>
                </ng-container>
            }
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>In datum range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input (dateChange)="filterChange()" [(ngModel)]="date_start" matStartDate placeholder="Start datum">
                    <input (dateChange)="filterChange()" [(ngModel)]="date_end" matEndDate placeholder="Eind datum">
                </mat-date-range-input>
                <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </div>
    }

    <div class="filter-group">
        <h2 class="h6 condensed">Groep</h2>
        <mat-checkbox (change)="filterChange()" [(ngModel)]="filter['type_lengtemarkering']" color="primary">
            Lengtemarkering
        </mat-checkbox>
        <mat-checkbox (change)="filterChange()" [(ngModel)]="filter['type_figuratie']" color="primary">
            Figuratie
        </mat-checkbox>
    </div>

    <div class="filter-group">
        <h2 class="h6 condensed">Materiaal</h2>
        @for (material of materials(); track material; let i = $index) {
            <mat-checkbox
                (change)="filterChange()"
                [(ngModel)]="filter['material_' + material.id]"
                color="primary">
                {{material.name}}
            </mat-checkbox>
        }
    </div>

    <div class="filter-group">
        <h2 class="h6 condensed">Diversen</h2>
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.primer"
            color="primary">
            Primer
        </mat-checkbox>
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.stake_out"
            color="primary">
            Uitzetten
        </mat-checkbox>
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.blast"
            color="primary">
            Stralen
        </mat-checkbox>
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.traffic_controllers"
            [disabled]="filter.no_traffic_controllers"
            color="primary">
            Verkeersregelaars
        </mat-checkbox>
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.no_traffic_controllers"
            [disabled]="filter.traffic_controllers"
            color="primary">
            Geen verkeersregelaars
        </mat-checkbox>
        @if (AuthorisationService.hasFeature('selectionShowAlwaysCheck')) {
            <mat-checkbox
                (change)="filterChange()"
                [(ngModel)]="filter.always_check"
                color="primary">
                Altijd controleren
            </mat-checkbox>
        }
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.turbo_burn"
            color="primary">
            Turbo branden
        </mat-checkbox>
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.manual_burn"
            color="primary">
            Handmatig branden
        </mat-checkbox>
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.overgrown"
            color="primary">
            Overgroeide kanten
        </mat-checkbox>
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.clean_surface"
            color="primary">
            Schoonmaken ondergrond
        </mat-checkbox>
    </div>

    <div class="filter-group">
        <h2 class="h6 condensed">Nacht</h2>
        <mat-button-toggle-group (change)="nightDayChange()" [(ngModel)]="nightDaySelection">
            <mat-button-toggle value="day">Dag</mat-button-toggle>
            <mat-button-toggle value="night">Nacht</mat-button-toggle>
            <mat-button-toggle value="both">Beide</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <div class="filter-group">
        <h2 class="h6 condensed">Overig</h2>
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.with_comment"
            color="primary">
            Met opmerking
        </mat-checkbox>
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.exclusive_material"
            color="primary">
            Zonder materiaal
        </mat-checkbox>
        <mat-checkbox
            (change)="filterChange()"
            [(ngModel)]="filter.priority_figuration"
            color="primary">
            Voorrangsfiguraties
        </mat-checkbox>
        @if (this.AuthorisationService.hasFeature('showDeletedPushpins')) {
            <mat-checkbox
                (change)="filterChange()"
                [(ngModel)]="filter.deleted"
                color="primary">
                Verwijderde punten
            </mat-checkbox>
        }
    </div>

    <div class="filter-group">
        <h2 class="h6 condensed">CROW</h2>
        <mat-button-toggle-group (change)="filterChange()" [(ngModel)]="filter['crow']" [multiple]="true">
            <mat-button-toggle value="Aplus">A+</mat-button-toggle>
            <mat-button-toggle value="A">A</mat-button-toggle>
            <mat-button-toggle value="B">B</mat-button-toggle>
            <mat-button-toggle value="C">C</mat-button-toggle>
            <mat-button-toggle value="D">D</mat-button-toggle>
            <mat-button-toggle value="X"><i class="fas fa-question-circle"></i></mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <div class="filter-group">
        <h2 class="h6 condensed">Verfkleur</h2>
        @for (paintColor of paintColors(); track paintColor; let i = $index) {
            <mat-checkbox
                (change)="filterChange()"
                [(ngModel)]="filter['paintColor_' + paintColor.id]"
                color="primary">
                {{paintColor.name}}
            </mat-checkbox>
        }
    </div>
</div>
